import React from 'react';
import { CellProps } from '../types';
import * as Styled from '../styles';

export const PageUrlCell = ({ val }: CellProps) => (
  <Styled.PageUrlCellStyled>
    <a
      href={val}
      target="_blank"
      rel="noreferrer"
    >
      {val}
    </a>
  </Styled.PageUrlCellStyled>
);
